import styled from 'styled-components'

export const FieldLabel = styled.label`
  display: block;
  font-weight: 600;
  color: rgb(99, 115, 129);
`

export const AccountLabel = styled(FieldLabel)`
  margin-top: 1.5rem;
`
